import { rgba } from '@shared/utils/style/rgba';

// Cash-fund / honeymoon-fund design tokens (Figma: Travel 2025/2026, node 53294-10868).
//
// TEMPORARY HOME — NOT a permanent indirection layer. These gold/cream values are variant-specific
// and joykit does not expose them yet, so this is the single source of truth shared across
// @apps/stays and @apps/registry (a direct @apps/X → @apps/Y import is forbidden; @shared/ is the
// sanctioned cross-app location).
//
// When a value is promoted into the joykit palette, DELETE its const here and use the joykit token
// inline at the call sites (matching the `mono3` / `newUITest1` convention) — do NOT keep an alias.
// The `// → gold*` notes mark the likely joykit target for that day. Whatever joykit has no home for
// (the alpha tints, the gradient) simply stays here.
export const HONEYMOON_FUND_GOLD = '#C9A961'; // → gold6
export const HONEYMOON_FUND_SUBTITLE_GOLD = '#8A6A30'; // → gold8
export const HONEYMOON_FUND_GOLD_TINT = '#FAF6EC'; // light cream callout bg → gold1
export const HONEYMOON_FUND_PAGE_BACKGROUND = '#FDFBF6';
export const HONEYMOON_FUND_TAG_GRADIENT = 'linear-gradient(90deg, #DDC58E 0%, #CDAD6B 100%)';
export const HONEYMOON_FUND_TAG_BORDER = '#ECDCB2';

// Tints derived from the base gold — keeps the #C9A961 hex in exactly one place.
export const HONEYMOON_FUND_HOVER_BG = rgba(HONEYMOON_FUND_GOLD, 0.1); // accented hover bg
export const HONEYMOON_FUND_ICON_CIRCLE_BG_SETTLED = rgba(HONEYMOON_FUND_GOLD, 0.12);
export const HONEYMOON_FUND_SETTLED_BORDER = rgba(HONEYMOON_FUND_GOLD, 0.25);

// Entry (solid-gold) state — white tints layered on top of the gold fill.
export const HONEYMOON_FUND_ICON_CIRCLE_BG_GOLD = rgba('#FFFFFF', 0.22);
export const HONEYMOON_FUND_BUTTON_BORDER_GOLD = rgba('#FFFFFF', 0.85);

// --- Non-color data (stays-only) ---------------------------------------------------------------
// Couple's available cash-fund balance (a TOTAL amount, in major currency units). The fund is
// applied to the whole stay: out-of-pocket total = max(0, stayTotal − balance), and the per-night
// figures are derived from that. Single swap point for the tile pricing and the "Highest Fund
// Savings" sort.
// TODO(TRAV-3348 follow-up): replace this static balance with the real cash-fund balance from BE.
export const CASH_FUND_STATIC_AVAILABLE_BALANCE = 400;
